function progressBarFn(onLoad) {

  let progressBar = document.querySelector('.post__progress');

  if (progressBar) {

    let bodyStyles = window.getComputedStyle(document.body);
    let headerHeightScrolled = parseInt(bodyStyles.getPropertyValue('--header-height-scrolled')) || 0;

    // Get hero height with fallback
    let heroElement = document.querySelector('.post .heroWithBG');
    let heroHeight = heroElement ? heroElement.offsetHeight : 0;

    // Get countdown height with better checking
    const countdownElement = document.querySelector('.eventCountdown');
    let countdownHeight = 0;
    if (countdownElement) {
      const countdownDisplay = window.getComputedStyle(countdownElement).display;
      const countdownVisibility = window.getComputedStyle(countdownElement).visibility;
      if (countdownDisplay !== 'none' && countdownVisibility !== 'hidden') {
        countdownHeight = countdownElement.offsetHeight;
      }
    }

    // Get admin bar height dynamically
    let adminBar = document.getElementById('wpadminbar');
    let adminBarHeight = 0;
    if (adminBar) {
      adminBarHeight = adminBar.offsetHeight; // Gets actual height (32px desktop, 46px mobile)
    }

    let progressTop = 0;
    let fixedOffset = 0;

    if (countdownHeight === 0) {
      progressTop = heroHeight + adminBarHeight + "px";
      fixedOffset = headerHeightScrolled;
    } else {
      progressTop = heroHeight + countdownHeight + adminBarHeight + "px";
      fixedOffset = countdownHeight + adminBarHeight;
    }

    const triggerStart = "top " + (fixedOffset) + "px";

    if (onLoad) {
      progressBar.style.top = progressTop;
    }

    var action = gsap.set('.post__progress', {
      paused: true
    });

    ScrollTrigger.create({
      trigger: '.post__progress',
      start: 'top',
      onEnter: () => action.play(),
      onLeaveBack: () => action.reverse(),
    });

    gsap.to('.post__progress', {
      value: 100,
      ease: 'none',
      scrollTrigger: {
        trigger: ".postBody",
        scrub: 0.3,
        end: 'bottom',
        invalidateOnRefresh: true
      }
    });

    ScrollTrigger.create({
      trigger: '.postBody',
      start: triggerStart,
      onEnter: () => {
        // Set the position of progressBar to fixed with top: 0
        progressBar.style.position = 'fixed';
        progressBar.style.top = (fixedOffset) + "px";
      },
      onLeaveBack: () => {
        // Recalculate current progressTop value to handle countdown changes
        const currentCountdownElement = document.querySelector('.eventCountdown');
        let currentCountdownHeight = 0;
        if (currentCountdownElement) {
          const countdownDisplay = window.getComputedStyle(currentCountdownElement).display;
          const countdownVisibility = window.getComputedStyle(currentCountdownElement).visibility;
          if (countdownDisplay !== 'none' && countdownVisibility !== 'hidden') {
            currentCountdownHeight = currentCountdownElement.offsetHeight;
          }
        }

        const currentHeroElement = document.querySelector('.post .heroWithBG');
        const currentHeroHeight = currentHeroElement ? currentHeroElement.offsetHeight : 0;

        const currentAdminBar = document.getElementById('wpadminbar');
        const currentAdminBarHeight = currentAdminBar ? currentAdminBar.offsetHeight : 0;

        const currentProgressTop = currentHeroHeight + currentCountdownHeight + currentAdminBarHeight + "px";

        // Revert the position of progressBar when leaving the trigger
        progressBar.style.position = 'absolute';
        progressBar.style.top = currentProgressTop;
      }
    });

    progressBar.style.opacity = 1;
  }
};

document.addEventListener("DOMContentLoaded", function () {

  /**********************************************************************************************/
  /* refresh scrolltriggers
  /**********************************************************************************************/

  ScrollTrigger.refresh();

  if (document.readyState === 'complete') {
    setTimeout(function () {
      ScrollTrigger.refresh();
    }, 0);
  } else {
    window.addEventListener('load', function () {
      setTimeout(function () {
        ScrollTrigger.refresh();
        // Recalculate progress bar after all assets loaded
        let progressBar = document.querySelector('.post__progress');
        if (progressBar) {
          ScrollTrigger.getAll().forEach(trigger => {
            if (trigger.trigger === progressBar || trigger.trigger === '.postBody') {
              trigger.kill();
            }
          });
          progressBarFn(true);
        }
      }, 100);
    });
  }

  /**********************************************************************************************/
  /*
  /**********************************************************************************************/


  const postTemplate = document.querySelector(".post");

  if (postTemplate) {

    /*
    * progress bar
    */

    let progressBar = document.querySelector('.post__progress');

    if (progressBar) {
      progressBarFn(true);
    };

    /*
    * Listen for countdown close to recalculate progress bar
    */
    const countdownCloseButtons = document.querySelectorAll('.eventCountdown__closeButton');

    countdownCloseButtons.forEach(button => {
      button.addEventListener('click', function () {
        // Delay to allow countdown to be hidden first
        setTimeout(() => {
          if (progressBar) {
            // Clear existing ScrollTriggers
            ScrollTrigger.getAll().forEach(trigger => {
              if (trigger.trigger === progressBar || trigger.trigger === '.postBody') {
                trigger.kill();
              }
            });
            // Reload progress bar with new values
            progressBarFn(true);
            ScrollTrigger.refresh();
          }
        }, 100);
      });
    });

    /*
    * time to read calc
    */

    // let copyElement = document.querySelector(".postBody__content");
    // let readTimeElement = document.querySelector(".post .postIntro__details-ttr-number");

    // if (readTimeElement) {

    //   // Initialize wordCount variable
    //   let wordCount = 0;

    //   // Get the text content of the element
    //   let copyText = copyElement.textContent;
    //   // Remove non-word characters and split by spaces to count words
    //   let words = copyText.replace(/[^\w ]/g, "").split(/\s+/);
    //   // Add the word count to wordCount
    //   wordCount += words.length;

    //   // Calculate reading time in minutes
    //   let readingTimeInMinutes = Math.floor(wordCount / 228) + 1;

    //   // Set the text content to readingTimeInMinutes
    //   readTimeElement.textContent = readingTimeInMinutes;

    // }

  }

});

window.addEventListener('resize', function (event) {
  ScrollTrigger.refresh();
  progressBarFn(false);
}, true);
